import React from 'react';
import Modal from '../Modal/Modal';
import { BarChart } from 'react-feather';
import localisation from '../../localisation.json';
import { LanguageContext } from '../App';

function Statistics() {
    const [isOpen, setIsOpen] = React.useState(false);
    const { language } = React.useContext(LanguageContext);
    const numberOfWins = Number(localStorage.getItem('numberOfWins')) || 0;
    const numberOfStreaks =
        Number(localStorage.getItem('numberOfStreaks')) || 0;
    const numberOfLosses = Number(localStorage.getItem('numberOfLosses')) || 0;

    return (
        <>
            <button className='hoverable-btn' onClick={() => setIsOpen(true)}>
                <BarChart className='header-icon' />
            </button>
            <div>
                <Modal
                    isOpen={isOpen}
                    title={
                        <div>{localisation[0].statistics.header[language]}</div>
                    }
                    handleDismiss={() => setIsOpen(false)}>
                    <div>
                        <p>
                            {localisation[0].statistics.gamesPlayed[language]}
                            {numberOfWins + numberOfLosses}
                        </p>
                        <p>
                            {localisation[0].statistics.gamesWon[language]}
                            {numberOfWins}
                        </p>
                        <p>
                            {
                                localisation[0].statistics.percentOfVictories[
                                    language
                                ]
                            }
                            {(
                                (numberOfWins /
                                    (numberOfWins + numberOfLosses)) *
                                    100 || 0
                            ).toFixed(2)}
                        </p>
                        <p>
                            {localisation[0].statistics.streak[language]}
                            {numberOfStreaks}
                        </p>
                    </div>
                </Modal>
            </div>
        </>
    );
}
export default Statistics;
